export const normalizeClinicId = (id) => {
  if (typeof id === 'string') {
    const trimmed = id.trim();
    if (!trimmed || trimmed.toLowerCase() === 'null' || trimmed.toLowerCase() === 'undefined') {
      return null;
    }
    return trimmed;
  }
  return id || null;
};
